import css from 'styled-jsx/css';
import { fontUrl } from '../../utils/staticUrls';

export const layoutStyle = () => {
  return css.global`
    @import 'static/styles/base.css';
    @import 'static/icons/style.css';
    @import '@digital-retail/falabella-ui-cross-components/dist/cross.component.styles.css';
    @import '@digital-retail/rating-and-reviews/dist/style.css';
    @font-face {
      font-family: Lato;
      src: url(${fontUrl('Lato-Black.woff2')});
      font-weight: 900;
      font-display: fallback;
    }
    @font-face {
      font-family: Lato;
      src: url(${fontUrl('Lato-Bold.woff2')});
      font-weight: 700;
      font-display: fallback;
    }
    @font-face {
      font-family: Lato;
      src: url(${fontUrl('Lato-BoldItalic.woff2')});
      font-weight: 700;
      font-style: italic;
      font-display: fallback;
    }
    @font-face {
      font-family: Lato;
      src: url(${fontUrl('Lato-Italic.woff2')});
      font-style: italic;
      font-display: fallback;
    }
    @font-face {
      font-family: Lato;
      src: url(${fontUrl('Lato-Light.woff2')});
      font-weight: 300;
      font-display: fallback;
    }
    @font-face {
      font-family: Lato;
      src: url(${fontUrl('Lato-LightItalic.woff2')});
      font-weight: 300;
      font-style: italic;
      font-display: fallback;
    }
    @font-face {
      font-family: Lato;
      src: url(${fontUrl('Lato-Regular.woff2')});
      font-weight: 400;
      font-display: fallback;
    }
    input::-ms-reveal,
    input::-ms-clear {
      display: none;
    }
    :global(.doc-click-overlay) {
      position: relative;
      display: flex;
      height: 100%;
      align-items: flex-end;
      justify-content: center;
      cursor: pointer;
    }
  `;
};
